<template>
  <el-dialog
    class="x-dialog"
    :visible.sync="visible"
    v-bind="$attrs"
    :close-on-click-modal="closeOnClickModal"
    :close-on-press-escape="closeOnPressEscape"
    :destroy-on-close="destroyOnClose"
    @open="handleOpen"
    @opened="handleOpened"
    @close="handleCancel"
    @closed="handleClosed"
    :width="width"
    :title="title"
  >
    <slot></slot>

    <span v-if="!$slots.footer" slot="footer" class="x-dialog-footer" v-show="footShow">
      <el-button @click="handleCancel" v-if="cancelShow">
        {{ cancelText }}
      </el-button>
      <el-button type="primary" :loading="submitLoading" @click="handleSubmit" v-if="submitShow">
        {{ submitText }}
      </el-button>
    </span>

    <div v-else slot="footer" class="x-dialog-footer" v-show="footShow">
      <slot name="footer" />
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'XDialog',
    inheritAttrs: true,
    props: {
      title: {
        type: String,
        default: '标题'
      },
      submitLoading: {
        type: Boolean,
        default: false
      },
      footShow: {
        type: Boolean,
        default: true
      },
      cancelShow: {
        type: Boolean,
        default: true
      },
      cancelText: {
        type: String,
        default: '取消'
      },
      submitShow: {
        type: Boolean,
        default: true
      },
      submitText: {
        type: String,
        default: '确定'
      },
      closeOnClickModal: {
        type: Boolean,
        default: false
      },
      closeOnPressEscape: {
        type: Boolean,
        default: false
      },
      destroyOnClose: {
        type: Boolean,
        default: false
      },
      show: {
        type: Boolean,
        default: false
      },
      width: {
        type: String,
        default: '60%'
      }
    },
    computed: {
      visible: {
        get() {
          return this.show
        },
        set(val) {
          this.$emit('update:show', val)
        }
      }
    },
    methods: {
      handleCancel() {
        this.$emit('onCancel')
      },
      handleSubmit() {
        this.$emit('onSubmit')
      },
      handleClosed() {
        this.$emit('onClosed')
      },
      handleOpen() {
        this.$emit('onOpen')
      },
      handleOpened() {
        this.$emit('onOpened')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .x-dialog-footer {
    display: flex;
    justify-content: end;
    padding: 10px;
    border-top: 1px solid #e0e0e0;
  }
</style>
